export interface AuthStateInfos {
  apiKeyRequestId?: string;
  authUrl?: string;
  tenant?: string;
  tenantUser?: string;
  tenantUserEmail?: string;
  apiKey?: string;
  status?: string;
}
